var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('navbar'),_c('v-main',{staticClass:"pa-2 main"},[_c('v-container',[_c('router-view')],1)],1),_c('rodape')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }